import { create } from '@bufbuild/protobuf'
import { type ConnectError } from '@connectrpc/connect'
import { useQuery } from '@connectrpc/connect-query'
import { type SplitSupplyNoticeKey } from '@ebalance/proto/bffuser/v1/split_supply_plan_model_pb'
import { getOwnSplitSupplyNotice } from '@ebalance/proto/bffuser/v1/split_supply_plan_service-SplitSupplyPlanService_connectquery'
import {
  GetOwnSplitSupplyNoticeRequestSchema,
  type GetOwnSplitSupplyNoticeResponse,
} from '@ebalance/proto/bffuser/v1/split_supply_plan_service_pb'
import type { UseQueryResult } from '@tanstack/react-query'

import { type CivilDate, civilDateToProtoDate } from '~/models/civilDate'

/**
 * 自社の通告値 1 通の 48 コマ (全地点) の取得 hook。 ある受渡日 1 日分か、 'all' で期間全体
 * (月間の通は対象月の全日。 受渡日を指定せずに取得する)。
 * key が無い (URL の query が壊れている) 間は取得しない。
 */
export function useGetOwnSplitSupplyNotice(
  key: SplitSupplyNoticeKey | undefined,
  deliveryDate: CivilDate | 'all' | undefined,
): UseQueryResult<GetOwnSplitSupplyNoticeResponse, ConnectError> {
  return useQuery(
    getOwnSplitSupplyNotice,
    create(GetOwnSplitSupplyNoticeRequestSchema, {
      key,
      deliveryDate:
        deliveryDate === undefined || deliveryDate === 'all'
          ? undefined
          : civilDateToProtoDate(deliveryDate),
    }),
    {
      enabled: key !== undefined && deliveryDate !== undefined,
      // 本番の既定は throwOnError: true (ErrorBoundary へ伝播)。 失敗は画面の中で案内するので伝播させない
      throwOnError: false,
    },
  )
}
